import { CLINICAL_INTAKE_FIELD_HOVER_INFO } from '../data/clinicalIntakeFieldHoverInfo';
import { buildAdministrativeExtractionGuidance } from '../data/administrativeFieldHoverInfo';

const flattenHoverTexts = (node, prefix = '') => {
  const out = {};
  if (!node || typeof node !== 'object' || Array.isArray(node)) return out;

  Object.entries(node).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string' && value.trim()) {
      out[path] = value.trim();
    } else if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.assign(out, flattenHoverTexts(value, path));
    }
  });
  return out;
};

const TRIAL_SCHEMA_GUIDANCE_KEY_PATTERN =
  /^(trial_schema_|upload_supporting_documents|doc_upload_|select_template)/;

/**
 * Merge default intake hover definitions with persisted ui_hover_texts overrides.
 * Custom edits win over defaults.
 */
export const buildClinicalIntakeFieldGuidance = (uiHoverTexts = null) => {
  const merged = { ...CLINICAL_INTAKE_FIELD_HOVER_INFO };
  const custom = flattenHoverTexts(uiHoverTexts);
  Object.entries(custom).forEach(([key, text]) => {
    merged[key] = text;
  });
  return merged;
};

/**
 * Guidance for Administrative Info + Trial Schema auto-populate (Source Documents step).
 */
export const buildAdminTrialSchemaFieldGuidance = (uiHoverTexts = null) => {
  const intakeGuidance = buildClinicalIntakeFieldGuidance(uiHoverTexts);
  const trialSchemaGuidance = Object.fromEntries(
    Object.entries(intakeGuidance).filter(([key]) => TRIAL_SCHEMA_GUIDANCE_KEY_PATTERN.test(key))
  );
  return {
    ...buildAdministrativeExtractionGuidance(),
    ...trialSchemaGuidance,
  };
};
